import React, { useContext } from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import UserProfileContext from '../context/userprofilecontext';
import * as Pages from '../pages';
import LoadingPage from '../pages/page-loading-page';
import NotFoundPage from '../pages/page-not-found-page';
import AccessDeniedPage from '../pages/page-access-denied';
import HomeDashboard from '../pages/page-home-redesign';
import MyAccountPage from '../pages/page-my-account';
import { AppShell } from '../design-system';

// All pages now render inside AppShell (the new three-panel layout).
// Individual pages may still use MUI internally — that's fine.
// The outer navigation shell is consistent across the entire app.
function ShellLayout() {
  return <AppShell><Outlet /></AppShell>;
}

export default function AppRoutes() {
  const { userProfile, isLoading } = useContext(UserProfileContext);

  if (isLoading || userProfile === null) {
    return <LoadingPage />;
  }

  const routes = userProfile.accessibleRoutes.map((route, index) => {
    const Component = Pages[route.component];
    if (!Component) {
      console.warn(`Component '${route.component}' not found.`);
      return null;
    }
    return <Route key={index} path={route.path} element={<Component />} />;
  }).filter(Boolean);

  // Routes the app has but this user's groups don't grant. Registering them
  // explicitly is what lets a permission miss say "you don't have access"
  // rather than falling through to the catch-all below and claiming the page
  // doesn't exist (Trello TYTHVoW2). The two sets are complements of one
  // permissions table, so they can't collide.
  const deniedRoutes = (userProfile.restrictedRoutes || []).map((route, index) => (
    <Route key={`denied-${index}`} path={route.path} element={<AccessDeniedPage />} />
  ));

  return (
    <Routes>
      <Route element={<ShellLayout />}>
        <Route path="/" element={<HomeDashboard />} />
        {/* Static route — every authenticated user manages their own account,
            so this is not gated by accessibleRoutes (RBAC). */}
        <Route path="/account" element={<MyAccountPage />} />
        {routes}
        {deniedRoutes}
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
